import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress
} from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { handleDownload } from 'src/utils/handleDownload';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import { apiService } from '../../api/axiosClient';
import DropzoneWrapper from '../../styles/react-dropzone';

const SynonymCard = props => {
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])

    const msg = `동의어 사전은 다음과 같은 포맷으로 파일에 입력해주세요. \
                \n 아이스, 얼음 => 냉장 \n 다이어트, 비건 => 건강`;

    const handleSynSubmit = async (event) => {
        event.preventDefault();

        if(files.length == 0) {
            toast.error('No file selection', {
                position: "top-center"
            })
            return false
        }

        setLoading(true)

        const [file] = files;
        const formData = new FormData();
        formData.append('file', file, 'synonym.txt');

        try {
            await apiService.post('/admin/search/synonym', formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            toast.success('업데이트 되었습니다.')
            setFiles([])
        } catch (error) {
            toast.error('업데이트 실패했습니다.')
            console.error('Error updating synonym:', error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <Card>
            <CardHeader title='동의어 사전 관리' titleTypographyProps={{ variant: 'h6' }} />                        
            <CardContent>
                <Alert severity='info' sx={{ whiteSpace: 'pre-line', mb:2 }}>{msg}</Alert>
                <Alert severity='error' sx={{mb:4}}>등록 애러가 발생하면 해당 단어를 <strong>"사용자 사전"</strong>에 등록해야합니다</Alert>
                <form onSubmit={handleSynSubmit} id="synonymform">
                    <DropzoneWrapper>
                        <FileUploaderSingle files={files} setFiles={setFiles} filetype={'text'}/>
                    </DropzoneWrapper>          
                </form>
            </CardContent>
            <CardActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'left' }}>
                <Button type="submit" form="synonymform" variant='contained' sx={{mr:4}}>
                    {loading ? (
                        <CircularProgress
                            sx={{
                            color: 'common.white',
                            width: '20px !important',
                            height: '20px !important',
                            mr: theme => theme.spacing(2)
                            }}
                        />
                    ) : null}
                    등록
                </Button>
                <Button variant='contained' color='warning' 
                    onClick={()=>handleDownload(`${process.env.REACT_APP_FILE_URL}/opensearch/synonym.txt`, 'synonym.txt')}>
                    Download
                </Button>
            </CardActions>
        </Card>
    )
}

export default SynonymCard